<template>
  <fvSelect class="form-control select text-right fv-size-md"
            v-model="valData"
            :options="options"
            :placeholder="placeholder"
            :multiple="multiple"
  >
    <template slot="value" slot-scope="scope">
      {{findValueObject(scope.value).text}}
    </template>
  </fvSelect>
</template>

<script>
  export default {
    props: {
      multiple: {
        type: Boolean,
        default: false
      },
      justId: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String
      },
      value: {
        type: Array,
      },
      required: [Boolean, Function],
    },
    data() {
      return {
        options: this.$store.state.main.usersRoles,
      }
    },
    computed: {
      valData: {
        get() {
          return this.value ? this.justId ? [this.value] : this.value : this.multiple ? [] : undefined
        },
        set(value) {
          const data = this.multiple ? value : [value]
          const result = this.justId ? data[0] : data
          this.$emit('input', result)
        }
      }
    },
    methods: {
      findValueObject(value) {
        if (this.multiple)
          return this.options.find((option) => option.value === value) || false;
        else
          return this.options.find((option) => option.value === value[0]) || false;
      },
    }
  }
</script>

<style lang="scss">
  .defaultIcon {
    &.female {
      color: #ff879d !important;
    }

    &.male {
      color: blue !important;
    }

  }

</style>
